module.exports = __webpack_public_path__ + "fonts/SamsungOne-400v10.1876c1c6.otf";